export class FileDto {
  OriginalName: string;
  FileContent: any;
}
